import _styled from "styled-components";
import cn from "clsx";
import CrehanaLogo from "@crehana/icons/logos/Crehana";
import CrehanaLive from "@crehana/icons/logos/CrehanaLive";
import CrehanaMicroDegree from "@crehana/icons/logos/CrehanaMicroDegree";
import CrehanaPremium from "@crehana/icons/logos/CrehanaPremium";
import FutureOfPeople from "@crehana/icons/logos/FutureOfPeople";
import { colors } from "@crehana/ui";
import useOrganizationTheme from "../../../hooks/useOrganizationTheme";
import OrganizationLogoImage from "./components/OrganizationLogoImage";
import { useMainMenuContext } from "../../hooks";
import { LOGO_WRAPPER_CLASSNAME } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
var Logo = function Logo(_ref) {
  var _me$organization, _me$organization3;
  var _ref$targetLink = _ref.targetLink,
    targetLink = _ref$targetLink === void 0 ? '_self' : _ref$targetLink;
  var _useMainMenuContext = useMainMenuContext(),
    themeName = _useMainMenuContext.themeName,
    theme = _useMainMenuContext.theme,
    urls = _useMainMenuContext.urls,
    me = _useMainMenuContext.me,
    logoTypeProp = _useMainMenuContext.logoType,
    layoutConfig = _useMainMenuContext.layoutConfig,
    handleLogoClick = _useMainMenuContext.handleLogoClick;
  var _layoutConfig$customS = layoutConfig.customSizeLogo,
    customSizeLogo = _layoutConfig$customS === void 0 ? 32 : _layoutConfig$customS;
  var organizationSlug = (me === null || me === void 0 ? void 0 : (_me$organization = me.organization) === null || _me$organization === void 0 ? void 0 : _me$organization.slug) || '';
  var _useOrganizationTheme = useOrganizationTheme(organizationSlug, {
      skip: !me.isB2B
    }),
    data = _useOrganizationTheme.data,
    loading = _useOrganizationTheme.loading;
  var defaultLogoType = me.isB2B ? 'b2b' : 'default';
  var logoType = logoTypeProp || defaultLogoType;
  var _ref2 = layoutConfig || {},
    _ref2$hideLeftLogo = _ref2.hideLeftLogo,
    hideLeftLogo = _ref2$hideLeftLogo === void 0 ? false : _ref2$hideLeftLogo;
  var isDark = themeName.nav === 'dark';
  var renderLogo = function renderLogo(logoClassName) {
    if (logoType === 'b2b') {
      var _me$organization2, _data$configuration, _lookAndFeel$primary, _lookAndFeel$primary2;
      var imageAlt = (data === null || data === void 0 ? void 0 : data.name) || ((_me$organization2 = me.organization) === null || _me$organization2 === void 0 ? void 0 : _me$organization2.name) || 'Crehana for Business';
      var logoImage = (isDark ? data === null || data === void 0 ? void 0 : (_data$configuration = data.configuration) === null || _data$configuration === void 0 ? void 0 : _data$configuration.darkModeLogo : data === null || data === void 0 ? void 0 : data.logo) || (data === null || data === void 0 ? void 0 : data.logo) || '';
      var lookAndFeel = data === null || data === void 0 ? void 0 : data.lookAndFeel;
      return /*#__PURE__*/_jsx(OrganizationLogoImage, {
        src: logoImage,
        alt: imageAlt,
        customSizeLogo: customSizeLogo,
        className: logoClassName,
        colors: {
          primary: (lookAndFeel === null || lookAndFeel === void 0 ? void 0 : (_lookAndFeel$primary = lookAndFeel.primary) === null || _lookAndFeel$primary === void 0 ? void 0 : _lookAndFeel$primary.main) || theme.nav.logo.color,
          secondary: (lookAndFeel === null || lookAndFeel === void 0 ? void 0 : (_lookAndFeel$primary2 = lookAndFeel.primary) === null || _lookAndFeel$primary2 === void 0 ? void 0 : _lookAndFeel$primary2.main) || theme.nav.logo.secondaryColor
        }
      });
    }
    if (logoType === 'premium') {
      return /*#__PURE__*/_jsx(CrehanaPremium, {
        size: customSizeLogo || 32,
        "aria-hidden": true,
        color: theme.nav.logo.color,
        secondaryColor: theme.nav.logo.secondaryColor,
        className: logoClassName
      });
    }
    if (logoType === 'microdegree') {
      return /*#__PURE__*/_jsx(CrehanaMicroDegree, {
        size: customSizeLogo || 24,
        "aria-hidden": true,
        color: theme.nav.logo.color,
        secondaryColor: theme.nav.logo.secondaryColor,
        className: logoClassName
      });
    }
    if (logoType === 'live') {
      return /*#__PURE__*/_jsx(CrehanaLive, {
        size: customSizeLogo || 32,
        "aria-hidden": true,
        color: theme.nav.logo.color,
        secondaryColor: theme.nav.logo.secondaryColor,
        className: logoClassName
      });
    }
    if (logoType === 'blog') {
      return /*#__PURE__*/_jsx(FutureOfPeople, {
        size: 18,
        "aria-hidden": true,
        color: colors.baseMain,
        className: logoClassName
      });
    }
    return /*#__PURE__*/_jsx(CrehanaLogo, {
      size: 16,
      "aria-hidden": true,
      color: theme.nav.logo.color,
      className: logoClassName
    });
  };
  if (hideLeftLogo || loading) {
    return null;
  }
  if (layoutConfig.disableLogoRedirection) {
    return renderLogo(LOGO_WRAPPER_CLASSNAME);
  }
  return /*#__PURE__*/_jsx(_StyledA, {
    id: "main-menu-logo",
    href: urls.home,
    onClick: handleLogoClick,
    className: cn('flex items-center', !layoutConfig.newSidebarEnabled && LOGO_WRAPPER_CLASSNAME, layoutConfig.leftLogoWrapperClassNames || '', layoutConfig.newSidebarEnabled && 'mr-auto'),
    "aria-label": ((_me$organization3 = me.organization) === null || _me$organization3 === void 0 ? void 0 : _me$organization3.name) || 'Crehana',
    target: targetLink,
    $_css: layoutConfig.newSidebarEnabled ? 'width: 256px; margin-left: -63px; justify-content: center; flex-shrink: 0;' : '',
    children: renderLogo()
  });
};
export default Logo;
var _StyledA = /*#__PURE__*/_styled("a").withConfig({
  componentId: "sc-14qedtn-0"
})(["\n        ", "\n      "], function (p) {
  return p.$_css;
});